module.exports = __webpack_public_path__ + "assets/185300317fbee465171b88ff12892f1f.png";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/images/overlay.png
 ** module id = 5
 ** module chunks = 0
 **/